import type { BookingTrackProps } from "../provider";

/**
 * The activity fields every funnel event carries, so a PostHog funnel can be
 * broken down by city / category / activity without each page re-deriving
 * them. Reads the loosely-typed detail shapes the pages already hold
 * (ActivityDetail, ShowActivity, BookingSheetActivity) without demanding one.
 */
export interface TrackableActivity {
  id: string;
  slug: string;
  title?: string;
  cityName?: string | null;
  citySlug?: string | null;
  city?: { name?: string; slug?: string } | null;
  categorySlug?: string | null;
  category?: { name?: string; slug?: string } | null;
}

export function activityTrackProps(a: TrackableActivity): BookingTrackProps {
  return {
    activity_id: a.id,
    activity_slug: a.slug,
    activity_title: a.title ?? undefined,
    city: a.citySlug ?? a.city?.slug ?? a.cityName ?? a.city?.name ?? undefined,
    category: a.categorySlug ?? a.category?.slug ?? a.category?.name ?? undefined,
  };
}
